import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  UserPreferencesSchema,
  UserPreferencesUpdateInput,
  OnboardingStateUpdateInput,
  UiPreferencesUpdateInput
} from '@app/core/api/user-preferences';

export const UserPreferencesActions = createActionGroup({
  source: 'User Preferences',
  events: {
    // Load preferences
    'Load Preferences': emptyProps(),
    'Load Preferences Success': props<{ preferences: UserPreferencesSchema }>(),
    'Load Preferences Failure': props<{ error: string }>(),

    // Update preferences
    'Update Preferences': props<{ data: UserPreferencesUpdateInput }>(),
    'Update Preferences Success': props<{ preferences: UserPreferencesSchema }>(),
    'Update Preferences Failure': props<{ error: string }>(),

    // Update onboarding state (merge)
    'Update Onboarding State': props<{ data: OnboardingStateUpdateInput }>(),
    'Update Onboarding State Success': props<{ preferences: UserPreferencesSchema }>(),
    'Update Onboarding State Failure': props<{ error: string }>(),

    // Update UI preferences (merge)
    'Update Ui Preferences': props<{ data: UiPreferencesUpdateInput }>(),
    'Update Ui Preferences Success': props<{ preferences: UserPreferencesSchema }>(),
    'Update Ui Preferences Failure': props<{ error: string }>(),

    // Set preferences directly (used by effects)
    'Set Preferences': props<{ preferences: UserPreferencesSchema }>(),

    // Clear preferences (used on logout)
    'Clear Preferences': emptyProps(),

    // Invalidate cache
    'Invalidate Cache': emptyProps(),
  }
});
